import AppEvents from './app-events';
import $ from 'jquery';

class DataSource {
    static #appPath = "";

    static #success = result => {
        if (result && result.RedirectUrl) {
            window.location.href = result.RedirectUrl;
        }

        if (result.Messages) {
            result.Messages.forEach((msg) => AppEvents.notify(msg));

            //$.each(result.Messages, (idx) => PubSub.publish("notify", result.Messages[idx]));
        }
    }

    static #fail = xhr => {
        if (xhr.status === 401) {
            var redirectUrl = xhr.responseText;

            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        }
    }

    static post = (url, data) => {
        return $.post(this.#appPath + url, data)
            .done(this.#success)
            .fail(this.#fail);
    };

    static postFormData = (url, data) => {
        return $.ajax({
            url: url,
            data: data,
            processData: false,
            contentType: false,
            type: 'POST'
        })
        .done(this.#success)
        .fail(this.#fail);
    }

    static get = (url, data) => {
        var url = this.#appPath + url;

        return $.get(url, data)
        //.done(this.#success)
        //.fail(this.#fail);
    };
}

export default DataSource;